import teamRequestsFiltersComponent from './teamRequestsFilters.component';

let teamRequestsFiltersModule = angular.module('vacations-absences.teamRequestsFilters', [])

.component('teamRequestsFilters', teamRequestsFiltersComponent)

.name;

export default teamRequestsFiltersModule;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/features/teamRequests/teamRequestsList/teamRequestsFilters/teamRequestsFilters.js